/* eslint-disable react/prop-types */
import { Button, Descriptions, Flex, Grid, Image, Modal, Typography } from "antd";
import { useState } from "react";
import { Link } from "react-router";
import { API_BASE_URL } from "../../../config/api.config";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useMutation } from "@tanstack/react-query";
import { rccService } from "../../../services/rcc.service";
import { downloadBlob } from "../../../utils/download";

export default function RccDescriptions({ registration, registrationId }){

  const breakpoint = Grid.useBreakpoint()

  const [previewImage, setPrevieImage] = useState('')

  const exportMutation = useMutation({
    mutationFn: () => rccService.exportRegistrationData(registrationId),
    onSuccess: ({ blob, filename }) => {
      downloadBlob(blob, filename)
    }
  })

  return (
    <>
      <Flex justify="end" >
        <Button onClick={exportMutation.mutate} loading={exportMutation.isPending} disabled={exportMutation.isPending} variant="filled" color="primary" icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}  >
          Export Data Registrasi
        </Button>
      </Flex>
      <Descriptions
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Informasi Pelanggan"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { span: 2, label: 'Nama Pelanggan', children: registration?.data?.nama_kustomer },
            { label: 'No Telepon', children: registration?.data?.nomor_kustomer },
            { label: 'Email', children: registration?.data?.email_kustomer },
            { label: 'Regional', children: registration?.data.ab.REGIONAL },
            { label: 'Area Bisnis', children: registration?.data.ab.NAMA_AB },
            { label: 'Kota', children: registration?.data?.kota_kustomer },
            { label: 'Kecamatan', children: registration?.data?.kecamatan_kustomer },
            { label: 'Kelurahan', children: registration?.data?.kelurahan_kustomer },
            { label: 'Jalan', children: registration?.data?.jalan_kustomer },
            { span: 2, label: 'No Rumah', children: registration?.data?.no_rumah_kustomer },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RT', children: registration?.data?.rt_kustomer },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RW', children: registration?.data?.rw_kustomer },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          style={{ marginTop: 24 }}
          size="small"
          title="Penanggung Jawab"
          styles={{ label: { width: 200 } }}
          items={[
            { span: 2, label: 'Nama Penanggung Jawab', children: registration?.data?.nama_pic },
            { label: 'No Telepon', children: registration?.data?.nomor_pic },
            { label: 'Email', children: registration?.data?.email_pic },
            { label: 'Kota', children: registration?.data?.kota_pic },
            { label: 'Kecamatan', children: registration?.data?.kecamatan_pic },
            { label: 'Kelurahan', children: registration?.data?.kelurahan_pic },
            { label: 'Jalan', children: registration?.data?.jalan_pic },
            { span: 2, label: 'No Rumah', children: registration?.data?.no_rumah_pic },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RT', children: registration?.data?.rt_pic },
            { span: breakpoint.lg ?  0.5 : 1 , label: 'RW', children: registration?.data?.rw_pic },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 180 } }}
          size="small"
          title="Informasi Bangunan"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { 
              label: 'Kebutuhan Air',
              children: registration?.data?.kebutuhan_air + 'm3'
            },
            { 
              label: 'Kategori Bangunan',
              children: registration?.data?.kategori_bangunan
            },
            { label: 'Ketersediaan Tangki', children: registration?.data?.ketersediaan_tangki },
            { label: 'Peruntukan Bangunan', span: 2, children: registration?.data?.peruntukan_bangunan },
            { label: 'Titik Lokasi Bangunan', span: 2, children: registration?.data?.alamat_bangunan },
            { label: 'Fasilitas yang tersedia dan Kapasitasnya', span: 2, children: registration?.data?.fasilitas_dan_kapasitas },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 180 } }}
          size="small"
          title="Data Rencana Kebutuhan Air"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { label: 'Jumlah Pengguna Gedung/Karyawan (Orang)', span: 2, children: registration?.data?.jumlah_pengguna_gedung },
            { label: 'Rencana Tahun Penyelesaian Bangunan (Tahun)', span: 2, children: registration?.data?.rencana_tahun_penyelesaian_bangunan },
            { label: 'Staging Kebutuhan Air', span: 2, children: registration?.data?.staging_kebutuhan_air },
          ]}
        />
        <Descriptions
          column={breakpoint.lg ? 2 : 1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 180 } }}
          size="small"
          title="Evaluasi Teknis"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { label: 'Apakah sudah ada sambungan PAM JAYA?', children: registration?.data?.sudah_ada_sambungan_pamjaya },
            { label: 'NOMEN/NOREK', children: registration?.data?.nomen },
            { label: 'Ketersediaan Reservoir', children: registration?.data?.reservoir },
            { label: 'Kapasitas Reservoir (m3)', children: registration?.data?.kapasitas_reservoir },
            { label: 'Sumber Air Lain', children: registration?.data?.sumber_air_lain },
            { label: 'Luas Tanah (m2)', children: registration?.data?.luas_tanah },
            { label: 'Luas Bangunan (m2)', children: registration?.data?.luas_bangunan },
            { label: 'Jumlah Lantai', children: registration?.data?.jumlah_lantai },
          ]}
        />
        <Descriptions
          column={1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 110 }, content: { width: '100%' } }}
          size="small"
          title="Dokumen"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { 
              label: 'KTP', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.ktp}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.ktp}
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.ktp}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.ktp}`)}
                      disabled={!registration?.data?.ktp}
                    >
                      Lihat
                    </Button>
                  </Flex>
                  
                </Flex>
              )
            },
            { 
              label: 'PBB', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.pbb}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.pbb}
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.pbb}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      disabled={!registration?.data?.pbb}
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.pbb}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'NPWP', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.npwp}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      disabled={!registration?.data?.npwp}
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.npwp}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      disabled={!registration?.data?.npwp}
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.npwp}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'IMB/IP', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.imb}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.imb}
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.imb}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      disabled={!registration?.data?.imb}
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.imb}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'SIUP', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.siup}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.siup}
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.siup}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.siup}`)}
                      disabled={!registration?.data?.siup}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'NPPKP', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.nppkp}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.nppkp}
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.nppkp}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      disabled={!registration?.data?.nppkp}
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.nppkp}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'Dokumen Pendukung', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.dokumen_pendukung}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.data?.dokumen_pendukung}
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.dokumen_pendukung}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.dokumen_pendukung}`)}
                      disabled={!registration?.data?.dokumen_pendukung}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
          ]}
        />
        <Modal
          open={previewImage.length > 0}
          centered
          title="Gambar"
          onCancel={()=> setPrevieImage('')}
          footer={[
            <Button variant="outlined" color="primary" key="cancel" onClick={() => setPrevieImage('')}>
              Cancel
            </Button>
          ]}
        >
          <Image src={previewImage} />
        </Modal>
    </>
  )
}